module.exports = __webpack_public_path__ + "ad24f7a5222fe8379114bc3e5f0f75ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/05_JET_03.png
// module id = 105
// module chunks = 0